<template>
    <div class="hero-head">
        <div class="columns is-mobile is-marginless heading has-text-weight-bold">
            <div class="column left">
                <figure class="nav-bar-item image">
                    <img src="../../assets/logo.png" alt="UNET - cars from Japan" style="width: 6.25rem; height: 2rem" />
                </figure>
            </div>
            <div class="column center desktop">
                <a href="#about" class="navbar-item has-text-white is-static">About Us</a>
                <a href="#faq" class="navbar-item has-text-white is-static">FAQ</a>
                <a href="#why" class="navbar-item has-text-white is-static">Auction</a>
                <a href="#offices" class="navbar-item has-text-white is-static">Contact</a>
            </div>
            <div class="column right">
                <router-link to="/login" class="navbar-item has-text-white is-static">Sign In</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        }
    }
</script>

<style scoped>
    @import '../../assets/css/home.css';
    .navbar-item:hover{
        background: none;
    }
    .navbar-item {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home/Navigation.vue